import {SearchOutlined} from '@ant-design/icons';

import {Select} from 'antd';
import {useSelector} from 'react-redux';


const SelectFilterTable = () => {
    const filter = useSelector((state) => state.TableRedux.filter);

    const getColumnSelectProps = (initialValue = '[]', dataIndex, placeholder, dataArray, getData, callbackData, loading = false, mode = "multiple") => (


        {
            filterDropdown: () => (<div className='p-3' onKeyDown={(e) => e.stopPropagation()}>

                <Select style={{width: '180px'}} defaultValue={JSON.parse(initialValue)} loading={loading}
                        value={filter[dataIndex] ? JSON.parse(filter[dataIndex]) : []}
                        filterOption={(input, option) => {

                            return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())

                        }}
                        optionFilterProp='label'
                        onChange={callbackData}
                        options={dataArray} mode={mode} allowClear placeholder={placeholder}/>


            </div>),
            filterIcon: (filtered) => {
                return <SearchOutlined style={{color: filter[dataIndex] ? 'blue' : undefined,}}/>
            },
            onFilter: (value, record) => {
                return record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            },
            onFilterDropdownOpenChange: (show) => {

                if (show && !dataArray?.length && getData) {
                    getData()
                }

            },

        });


    return [getColumnSelectProps];
};

export default SelectFilterTable;